import { render, staticRenderFns } from "./InitialLoading.vue?vue&type=template&id=ef473200&"
import script from "./InitialLoading.vue?vue&type=script&lang=js&"
export * from "./InitialLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports